import axios from 'axios'
import qs from 'qs'
import store from '../store'
import router from "../router";
import { mapState } from 'vuex'
const HOST = BASEURL

import {
  Message
} from 'element-ui'

const defaultAxios = axios.create({
  baseURL: '',
  timeout: 600000,
  withCredentials: false
})

//请求拦截器
defaultAxios.interceptors.request.use((config) => {
  // 从本地存储获取 token
  const token = localStorage.getItem('token') || '';
   // 去除 token 两端的引号
  const cleanedToken = token.replace(/^"|"$/g, '');
  
  // 从本地存储获取 language
  const language = Number(localStorage.getItem('language')) || '';
  
  if (token) {
    // 将 token 添加到请求头
    config.headers['token'] = cleanedToken;
  }
  if (language) {
    // 将 language 添加到请求头
    config.headers['Language'] = language;
  }
  return config
})

//响应拦截器
defaultAxios.interceptors.response.use((response) => {
  if(response.data.token){
    return response.data
  }
  
  const {  code,msg } = response.data
  if (code === 200 || code === 0) {
    //请求成功,返回请求体的data
    return response.data
  } else if (code === -2) {
      store.dispatch('clearAdminUserInfo')
      Message.error('登录失效，请重新登录')
      router.replace('/')
  }else{
      if(msg == '无效令牌，需要重新获取'){
          store.dispatch('clearAdminUserInfo')
          Message.error('登录失效，请重新登录')
          router.replace('/')
          return  false
      }
    return response.data
  }
})

export const get = (url, params, config = {}) => {
  return new Promise((reslove, reject) => {
    let httpOption = {
      method: 'GET',
      url,
      params,
      ...config
    }
    defaultAxios(httpOption).then(response => {
      reslove(response)
    }).catch(error => {
      reject(error)
    })
  })
}

export const post = (url, data, config = {}) => {
  return new Promise((reslove, reject) => {
    if (config.form) {
      let headers = {}
      data = qs.stringify(data, {
        allowDots: true
      })
      headers['Content-Type'] = 'application/json'
      config.headers = Object.assign(headers, config.headers)
    }
    let httpOption = {
      method: 'POST',
      url,
      data,
      ...config
    }
    defaultAxios(httpOption).then(response => {
      reslove(response)
    }).catch(error => {
      reject(error)
    })
  })
}

export const postForm = (url, data, config = {}) => {
  return new Promise((reslove, reject) => {
    const formData = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        formData.append(key, data[key]);
      }
    }
    let httpOption = {
      method: 'POST',
      url,
      data: formData,
      ...config
    }
    defaultAxios(httpOption).then(response => {
      reslove(response)
    }).catch(error => {
      reject(error)
    })
  })
}

export const del = (url, params, config = {}) => {
    return new Promise((reslove, reject) => {
    let httpOption = {
      method: 'DELETE',
      url,
      params,
      ...config
    }
    defaultAxios(httpOption).then(response => {
      reslove(response)
    }).catch(error => {
      reject(error)
    })
  })
}

export const put = (url, data, config = {}) => {
  return new Promise((reslove, reject) => {
    let httpOption = {
      method: 'PUT',
      url,
      data,
      ...config
    }
    defaultAxios(httpOption).then(response => {
      reslove(response)
    }).catch(error => {
      reject(error)
    })
  })
}

export const patch = (url, data, config = {}) => {
    return new Promise((reslove, reject) => {
        if (config.form) {
            let headers = {}
            data = qs.stringify(data, {
                allowDots: true
            })
            headers['Content-Type'] = 'application/x-www-form-urlencoded'
            config.headers = Object.assign(headers, config.headers)
        }
        let httpOption = {
            method: 'PATCH',
            url,
            data,
            ...config
        }
        defaultAxios(httpOption).then(response => {
            reslove(response)
        }).catch(error => {
            reject(error)
        })
    })
}